<script setup lang="ts">
import { XModal } from '@clicksign/excalibur';

import { BrandButton } from '~~base-ui';

export type CertificateModalHowItWorksEmit = {
  (event: 'close'): void;
};

const emit = defineEmits<CertificateModalHowItWorksEmit>();

function close() {
  emit('close');
}
</script>

<template>
  <XModal
    :is-open="true"
    :backdrop-classes="[$style.backdrop]"
    role="dialog"
    width="332"
    data-testid="webPkiHelpModal"
    @close="close()"
  >
    <template #default>
      <h4>
        {{ $t('requirement.digitalCertificate.local.modal.webPkiHelp.title') }}
      </h4>

      <p :class="$style.text">
        {{ $t('requirement.digitalCertificate.local.modal.webPkiHelp.description') }}
      </p>

      <h4>
        {{ $t('requirement.digitalCertificate.local.modal.webPkiHelp.howToUse') }}
      </h4>

      <ul :class="[$style.list, $style.text]">
        <li>
          {{ $t('requirement.digitalCertificate.local.modal.webPkiHelp.installExtenssion') }}
        </li>

        <li>
          {{ $t('requirement.digitalCertificate.local.modal.webPkiHelp.selectCertificate') }}
        </li>

        <li>
          {{ $t('requirement.digitalCertificate.local.modal.webPkiHelp.authorize') }}
        </li>

        <li>
          {{ $t('requirement.digitalCertificate.local.modal.webPkiHelp.typeThePin') }}
        </li>
      </ul>
    </template>

    <template #actions>
      <BrandButton
        data-testid="modalCloseButton"
        @click="close()"
      >
        {{ $t('requirement.common.close') }}
      </BrandButton>
    </template>
  </XModal>
</template>

<style lang="scss" module src="./style.module.scss" />
